import { Box, Button, Stack, Text } from '@chakra-ui/react';

const PhotoChoiceModal = ({ isOpen, onClose, onUpload, onCamera }) => {
  if (!isOpen) return null;

  return (
    <Box position="fixed" inset="0" zIndex="1400">
      <Box
        position="absolute"
        inset="0"
        bg="blackAlpha.600"
        onClick={onClose}
      />
      <Box
        position="absolute"
        top="50%"
        left="50%"
        transform="translate(-50%, -50%)"
        bg="white"
        w={{ base: '92%', sm: '360px' }}
        borderRadius="md"
        p={{ base: 4, sm: 6 }}
        boxShadow="lg"
      >
        <Text fontSize="lg" fontWeight="semibold" mb={4}>
          Select Photo Source
        </Text>
        <Stack spacing={3}>
          <Button onClick={onUpload} variant="outline" colorScheme="blue" w="full">
            Upload from device
          </Button>
          <Button onClick={onCamera} variant="outline" colorScheme="blue" w="full">
            Take photo
          </Button>
          <Button onClick={onClose} variant="ghost" w="full">
            Cancel
          </Button>
        </Stack>
      </Box>
    </Box>
  );
};

export default PhotoChoiceModal;
